"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CtaContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="252618" id="cta-contact" className="bg-secondary py-24 md:py-32">
      <div ref={ref} className={`page-container flex flex-col items-center justify-center text-center space-y-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="space-y-5 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-foreground font-default tracking-tight">
            Implementa AvStream Connect en tu empresa
          </h2>
          <p className="text-lg md:text-xl text-secondary-foreground/90 font-default max-w-2xl mx-auto leading-relaxed">
            Optimiza tus comunicaciones y potencia la productividad de tu equipo con nuestra integración avanzada.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 primary-button font-semibold text-base px-8 h-14 shadow-md transition-transform hover:scale-105 rounded-md">
            <Link to="/MsTeamsIntegrationPage">
              Solicitar Demo
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="bg-transparent border-secondary-foreground text-secondary-foreground hover:bg-secondary-foreground/10 font-semibold text-base px-8 h-14 shadow-md transition-transform hover:scale-105 rounded-md">
            <Link to="#">
              Contactar Ventas
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}